import { Module } from '@nestjs/common';
import { LeadsService } from './leads.service';
import { LeadsController } from './leads.controller';
import { LeadsEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';

@Module({
  controllers: [LeadsController],
  providers: [LeadsService],
  imports: [TypeOrmModule.forFeature([LeadsEntity])],
})
export class LeadsModule {}
